import Card, { ICardProps } from "components/Card";
import { cx } from "utils";


export function BillingDetailsCardTitle(
  {
    title,
    subtitle,
    isPrimary,
    primaryLabel = "DEFAULT"
  }: {
    title: string,
    subtitle?: string,
    isPrimary?: boolean,
    primaryLabel?: string
  }
) {
  return (
    <div className="flex flex-col gap-y-2">
      <div className="flex items-center gap-x-2">
        <div className="text-base">{ title }</div>
        { isPrimary && (
          <span className="px-1.5 h-[22px] flex items-center text-[11px] leading-4 font-normal bg-neutral-600 text-white rounded-sm">
            { primaryLabel }
          </span>
        ) }
      </div>
      { subtitle && (
        <div className="text-sm font-normal text-gray-600">{ subtitle }</div>
      ) }
    </div>
  );
}

export default function BillingDetailsCard(
  {
    id,
    title,
    subtitle,
    extra,
    animation,
    contentKey,

    className,
    children,
  }: {
    id?: string;
    title: string;
    subtitle?: string;
    extra?: ICardProps["extra"];
    animation?: ICardProps["animation"];
    contentKey?: ICardProps["contentKey"];

    className?: ICardProps["className"];
    children?: ICardProps["children"];
  }
) {
  return (
    <Card
      id={ id }
      title={ <BillingDetailsCardTitle title={ title } subtitle={ subtitle }/> }
      extra={ extra }
      size="XL"
      animation={ animation }
      contentKey={ contentKey }
      className={ cx(className, id && "!scroll-mt-[190px]") } // extra scroll margin for the sticky navigation header on the billing page
    >
      { children }
    </Card>
  );
};
